/**
 * Angular imports
 */
import {bootstrap} from 'angular2/platform/browser';
import {provide, PLATFORM_DIRECTIVES, enableProdMode} from 'angular2/core';
import {ROUTER_PROVIDERS, ROUTER_DIRECTIVES} from 'angular2/router';
import {LocationStrategy, HashLocationStrategy} from 'angular2/platform/common';

import {AppComponent} from './app.component';
import {KeycloakService} from "./http/keycloak.service";
import {App} from "./app_config";

if (! App.AppConfig.isDev) {
    enableProdMode();
}

/**
 * Keycloak initialisation
 */
KeycloakService.init().then(() => {
    // If initialization successful, triggering of the AppComponent bootstrap
    bootstrap(AppComponent, [
        ROUTER_PROVIDERS,
        provide(LocationStrategy, {useClass: HashLocationStrategy}),
        provide(PLATFORM_DIRECTIVES, {useValue: [ROUTER_DIRECTIVES], multi: true})
    ]);
}).catch(error => console.error('main.ts => App component bootstrap failed ', error));
